import { PublicCertificateNavigator } from '@certificate/certificate-navigator';
import { useParams } from '@certificate/router';

export default function SocialMediaPage() {
  const { examEventExamineeId } = useParams(
    '/exam-event-examinees/:examEventExamineeId/social-media',
  );

  return (
    <PublicCertificateNavigator examEventExamineeId={examEventExamineeId} type='social-media' />
  );
}
